import { Actions, thunk } from 'easy-peasy';
import { IStoreModel } from '~/store/types';
import api from '~/services/api';
import { IUserRole } from '~/types';
import getAccessibleTeamIdsForClinic from '../getAccessibleTeamIdsForClinic';
import { IActTeamActions, IThunkGetClinicActTeams } from '../types';

const onGetClinicActTeams: IThunkGetClinicActTeams = thunk(
  async ({ setActTeams }: Actions<IActTeamActions>, payload, { getStoreState }) => {
    const { clinicId, params } = payload;
    const store = getStoreState() as IStoreModel;
    const { current } = store.user;

    const currentRole = current?.roles?.find(
      role => role.id === current.roleId && role.clinic?.id === Number(clinicId),
    );
    const isLocalAdmin = currentRole?.name === IUserRole.LocalAdmin;

    const teamIdsInClinic = getAccessibleTeamIdsForClinic(current, clinicId, currentRole);

    const { items, total } = await api.actTeam
      .getClinicActTeams(clinicId, params)
      .then(r => r.data);
    const pagination = { ...params, total };

    setActTeams({
      items:
        isLocalAdmin || !current?.clinic?.id
          ? items
          : items.filter(item => teamIdsInClinic.includes(item.id)),
      pagination,
    });
  },
);

export default onGetClinicActTeams;
